import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
export var browse = {
  name: "xi606m",
  styles: "text-align:center;"
};
export var browseAllACT = /*#__PURE__*/css("display:inline-block;margin-left:12px;padding:8px 10px 7px;border:1px solid ", colour.accent, ";border-radius:3px;background-color:", colour.white, ";color:", colour.accent, ";font-size:", font.smallFontSize, ";font-weight:", font.headingFontWeight, ";text-decoration:none;min-width:166px;&:focus{outline:0;}");
export var separator = /*#__PURE__*/css("display:inline-block;padding-right:6px;padding-left:14px;color:", colour.neutral600, ";");
var recentSearchTitleFontSize = 12;
export var searchHead = /*#__PURE__*/css("padding-left:14px;margin-bottom:5px;color:", colour.neutral700, ";font-family:$ ", font.headingFontFamily, ";font-size:", recentSearchTitleFontSize, "px;font-weight:", font.headingFontWeight, ";text-transform:uppercase;opacity:0.5;");
export var recentSearches = {
  name: "13brihr",
  styles: "text-align:left;"
};
export var search = {
  name: "1yvko04",
  styles: "margin:18px 16px 15px 13px;text-align:left;"
};